import { useState, useCallback } from "react";
import { AnimatePresence } from "framer-motion";
import { Lightbox } from "@/components/GaleriaGrid";

// Hook reutilizable para abrir un carrusel/lightbox desde cualquier grilla de imágenes.
// open(fotos, index) abre el lightbox en la imagen clickeada; portal renderiza el overlay.
export function useLightbox() {
  const [state, setState] = useState(null); // { fotos, index }
  const open = useCallback((fotos, index) => setState({ fotos, index }), []);
  const close = useCallback(() => setState(null), []);
  const nav = useCallback(
    (d) => setState((s) => (s ? { ...s, index: (s.index + d + s.fotos.length) % s.fotos.length } : s)),
    []
  );
  const portal = (
    <AnimatePresence>
      {state && <Lightbox fotos={state.fotos} index={state.index} onClose={close} onNav={nav} />}
    </AnimatePresence>
  );
  return { open, portal };
}
